import {
    SPARE_PARTS_ORDERS_ATTACHMENTS_SAVED,
    SPARE_PARTS_ORDERS_ATTACHMENTS_SAVED_ERROR,
    SPARE_PARTS_ORDERS_GENERATED_PRESIGNED_URLS,
    SPARE_PARTS_ORDERS_CAR_REQUEST_GENERATED_PRESIGNED_URLS,
    SPARE_PARTS_ORDERS_CAR_REQUEST_ATTACHMENTS_SAVED,
    SPARE_PARTS_ORDERS_CAR_REQUEST_ATTACHMENTS_SAVED_ERROR,
} from '../../constants/websocketCommands';
import {
    SPARE_PARTS_ORDERS_ATTACHMENTS_UPLOADING,
    SPARE_PARTS_ORDERS_ATTACHMENTS_UPLOADING_ERROR
} from "../../actions/orders/actionAttachments";
import {SPARE_PARTS_RESET} from "../../actions/orders/actionTicket";

export const sparePartsOrderAttachment = (state = {
    correlationId: null,
    isTicketAttachmentUploading: false,
    isCarRequestAttachmentUploading: false,
    attachmentsForUpload: [],
    carRequestAttachmentsForUpload: [],
    carRequestUuid: null,
    uploadingCarRequest: false,
}, action) => {
    switch (action.type) {
        case SPARE_PARTS_RESET: {
            return Object.assign({}, state, {
                correlationId: null,
                isTicketAttachmentUploading: false,
                attachmentsForUpload: [],
                carRequestAttachmentsForUpload: [],
            });
        }
        case SPARE_PARTS_ORDERS_GENERATED_PRESIGNED_URLS: {
            const { attachments } = action.payload;
            return Object.assign({}, state, {
                attachmentsForUpload: Array.isArray(attachments) ? attachments : [],
            });
        }
        case SPARE_PARTS_ORDERS_CAR_REQUEST_GENERATED_PRESIGNED_URLS: {
            const { attachments, carRequestUuid } = action.payload;
            return Object.assign({}, state, {
                carRequestAttachmentsForUpload: Array.isArray(attachments) ? attachments : [],
                carRequestUuid,
            });
        }
        case SPARE_PARTS_ORDERS_ATTACHMENTS_UPLOADING: {
            const uploadingCarRequest = state.attachmentsForUpload.length === 0 && state.carRequestAttachmentsForUpload.length > 0;
            if (uploadingCarRequest) {
                return Object.assign({}, state, { 
                    isCarRequestAttachmentUploading: true,
                    uploadingCarRequest: true,
                });
            } else {
                return Object.assign({}, state, { 
                    isTicketAttachmentUploading: true,
                    uploadingCarRequest: false,
                });
            }
        }
        //att done + error
        case SPARE_PARTS_ORDERS_ATTACHMENTS_SAVED_ERROR:
        case SPARE_PARTS_ORDERS_ATTACHMENTS_UPLOADING_ERROR: {
            return Object.assign({}, state, {
                isTicketAttachmentUploading: false,
                attachmentsForUpload: [],
            });
        }
        case SPARE_PARTS_ORDERS_CAR_REQUEST_ATTACHMENTS_SAVED_ERROR: {
            return Object.assign({}, state, {
                isCarRequestAttachmentUploading: false,
                carRequestAttachmentsForUpload: [],
            });
        }
        case SPARE_PARTS_ORDERS_ATTACHMENTS_SAVED: {
            const { correlationId } = action.payload;

            if (correlationId < state.correlationId) {
                return state;
            }
            return Object.assign({}, state, {
                correlationId,
                isTicketAttachmentUploading: false,
                attachmentsForUpload: [],
            });
        }
        case SPARE_PARTS_ORDERS_CAR_REQUEST_ATTACHMENTS_SAVED: {
            const { correlationId } = action.payload;

            if (correlationId < state.correlationId) {
                return state;
            }
            return Object.assign({}, state, {
                correlationId,
                isCarRequestAttachmentUploading: false,
                carRequestAttachmentsForUpload: [],
            });
        }
        default:
            return state;
    }
};
